export default "/dist/files/icon_accompagnateurs.bc661cdefa9a8ab2c77c54cda44d43bb.svg";